import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Chatbot from "../../component/chatboat/chatboatUI";
import LeftSection from "../../component/dashboard-section/panels/left-panel";
import RightSection from "../../component/dashboard-section/panels/right-panel";
import MainSection from "../../component/dashboard-section/profile-complete/main";

import { useDispatch, useSelector } from "react-redux";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import * as DataAction from "../../store/actions/data/DataAction";

import { hasValidLoginCredentials } from "../../utils/storageUtils";
import BaseUrl from "../../constants/BaseUrl";

const Dashboard = () => {
  const [activeComponent, setActiveComponent] = useState("Home");
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const { loginSuccess, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleItemClick = (componentName) => {
    if (componentName === "Logout") {
      dispatch(AuthAction.LogoutAction());
      navigate("/login", { replace: true });
      return;
    }

    setActiveComponent(componentName); // Update active component
  };

  useEffect(() => {
    if (loginSuccess) {
      dispatch(
        AuthAction.GetLandlordProfile(
          loginSuccess?.user?._id,
          loginSuccess.token
        )
      );
      dispatch(DataAction.GetAllMasterData());

      // Fetch subscription status to gate sidenav
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${loginSuccess.token}`);
      fetch(
        `${BaseUrl}landlord/profile/getAllSubscriptions/${loginSuccess.user._id}`,
        { method: "GET", headers, redirect: "follow" }
      )
        .then((r) => r.json())
        .then((result) => {
          const subs = result?.data || [];
          setHasActiveSubscription(subs.some((s) => s.status === "active"));
        })
        .catch(() => {});
    } else {
      // Fallback: try to hydrate state if not already done
      if (hasValidLoginCredentials()) {
        dispatch(AuthAction.HydrateStateAction());
      } else {
        // No login data found, redirect to login
        navigate("/login", { replace: true });
      }
    }
  }, [loginSuccess, dispatch, navigate]);

  const [showBot, setShowBot] = useState(false);

  return (
    <div className="flex justify-center items-center w-[98%] mx-auto h-screen">
      {userCompleteProfile?.approved && (
        <>
          <div className="w-[20%] h-[97vh]">
            <LeftSection onItemClick={handleItemClick} hasActiveSubscription={hasActiveSubscription} />
          </div>
          <div className="w-[80%] pl-6 h-screen overflow-scroll scrollbar-hide panelScroll">
            <RightSection
              showChatBot={(val) => {
                setShowBot(val);
              }}
              activeComponent={activeComponent}
              setActiveComponent={setActiveComponent}
            />
          </div>
          {showBot && <Chatbot />}
        </>
      )}

      {userCompleteProfile && !userCompleteProfile?.approved && (
        <div className="w-[90%] mx-auto">
          <MainSection />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
